import { Dispatch, SetStateAction, useEffect } from "react"
import { FormControl, FormHelperText, TextField } from "@mui/material"
import { TestResultForm, TestResultFormErrors } from "../../types"

type TDSField = {
  formData: TestResultForm,
  setFormData: Dispatch<SetStateAction<TestResultForm>>,
  formErrors: TestResultFormErrors,
  setFormErrors: Dispatch<SetStateAction<TestResultFormErrors>>,
}

const TDSField = (props: TDSField) => {
  const { formData, setFormData, formErrors, setFormErrors } = props

  const handleChange = (value: string) => {
    const nextForm = structuredClone(formData)

    nextForm.TDS = value || null

    setFormData(nextForm)
  }

  useEffect(() => {
    const nextErrors = structuredClone(formErrors)

    const isValidNumber = Number.isFinite(Number(formData.TDS))
    const hasError = Boolean(formData.TDS) && !isValidNumber

    nextErrors.TDS = hasError

    setFormErrors(nextErrors)
  }, [formData.TDS])  

  const label = 'TDS'
  const value = formData.TDS ?? ''
  const placeholder = 'Optional'
  const hasError = formErrors.TDS

  return (
    <FormControl fullWidth size="small">
      <TextField
        size="small"
        label={label}
        onChange={(event) => handleChange(event.target.value)}
        value={value}
        placeholder={placeholder}
        error={hasError}
      />
      {
        hasError && (
          <FormHelperText error>
            TDS must be a number
          </FormHelperText>
        )
      }
    </FormControl>
  )
}

export default TDSField
